import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    table: {
        fontSize: '13px',
        color: 'inherit',
        '& .MuiDataGrid-columnHeadersInner': {
            background: '#F4F6F8',
        },
        '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-row:nth-of-type(odd)': {
            background: '#F4F6F8',
        },
        '& .MuiDataGrid-virtualScroller': {
            overscrollBehavior: 'contain',
        },
    },
});
